//#region Libraries
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
//#endregion
//#region Styles
import { Container, Content } from "views/components/AttendanceList/styles";
//#endregion
//#region Components
import HelmetUTP from "components/HelmetUTP/HelmetUTP";
import BackToView from "components/BackToView/BackToView";
import Preloader from "components/Preloader/Preloader";
import ToastMessage from "components/ToastMessage/ToastMessage";
import CustomTableList from "components/CustomTableList/CustomTableList";
import HeaderComponent from "./components/HeaderComponent/HeaderComponent";
import Footer from "./components/Footer/Footer";
import DialogResultSearchStudent from "./components/DialogResultSearchStudent/DialogResultSearchStudent";
import DialogExitWithoutSaveAttendance from "./components/DialogExitWithoutSaveAttendance/DialogExitWithoutSaveAttendance";
import DialogSaveAttendance from "./components/DialogSaveAttendance/DialogSaveAttendance";
import AttendanceFields from "./components/AttendanceFields/AttendanceFields";
import AllStudentReservationsCheckbox from "./components/AllStudentReservationsCheckbox/AllStudentReservationsCheckbox";
import TakeTeacherAttendancePanel from "./components/TakeTeacherAttendancePanel/TakeTeacherAttendancePanel";
import ListItem from "./components/ListItem/ListItem";
//#endregion
//#region Utils
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import { HEADERS_TABLE_LIST, HEADERS_TABLE_LIST_SANCIONADOS } from "./utils/constants";
import { useNavigatingAway } from "utils/hooks/usePrompt";
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import useStudentReservations from "./utils/hooks/useStudentReservations";
import useEventDataForAttendance from "./utils/hooks/useEventDataForAttendance";
import usePinReservationStudent from "./utils/hooks/usePinReservationStudent";
import useAddStudentReservation from "./utils/hooks/useAddStudentReservation";
import useFoundStudentList from "./utils/hooks/useFoundStudentList";
import useStudentToAdd from "./utils/hooks/useStudentToAdd";
import useLoadingRequest from "components/Preloader/utils/hooks/useLoadingRequest";
import useSaveAttendance from "./utils/hooks/useSaveAttendance";
import useSearchStudent from "./utils/hooks/useSearchStudent";
import useSearchedStudentField from "./utils/hooks/useSearchedStudentField";
import ListItemSancionado from "./components/ListItem/ListItemSancionado";
import useStudentSanctioned from "./utils/hooks/useStudentSanctioned";
//#endregion

const EventAttendanceComponent = () => {
	const navigate = useNavigate();
	const $content = useRef();
	//#region States
	const loadingRequest = useLoadingRequest();
	const [
		hiddenToastSuccessAddReservation,
		setHiddenToastSuccessAddReservation,
	] = useState(true);
	const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
		useState(false);
	//#endregion
	const dialogResultSearchStudent = useShowDialogAlert();
	const dialogSaveAttendance = useShowDialogAlert();
	const eventData = useEventDataForAttendance();
	const foundStudentList = useFoundStudentList();
	const studentToAdd = useStudentToAdd();
	const studentReservations = useStudentReservations({
		goToEventList,
		loadingRequest,
		eventData,
		$content,
		clearFoundStudentList: foundStudentList.clear,
	});
	const studentSanctioned = useStudentSanctioned({
		goToEventList,
		loadingRequest,
		eventData
	})
	const saveAttendanceHandler = useSaveAttendance({
		dialogSaveAttendance,
		setCanShowDialogLeavingPage,
		studentReservations,
		loadingRequest,
	});
	const { attendanceAllStudents } = studentReservations;
	const pinReservationStudent = usePinReservationStudent({
		clearFoundStudentList: foundStudentList.clear,
		$content,
		studentReservations,
	});
	const searchStudent = useSearchStudent({
		loadingRequest,
		studentReservationExists: studentReservations.exists,
		dialogResultSearchStudent,
		studentToAdd,
		toastErrorSaveAttendance:
			saveAttendanceHandler.toastErrorSaveAttendance,
	});
	const searchedStudent = useSearchedStudentField({
		foundStudentList,
		studentReservations: studentReservations.value,
	});
	//#region Manejo de salida de vista
	const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
		useNavigatingAway(canShowDialogLeavingPage);
	//#endregion
	//#region Functions
	const addStudentReservation = useAddStudentReservation({
		dialogResultSearchStudent,
		eventData: eventData.value,
		setHiddenToastSuccessAddReservation,
		loadingRequest,
		studentReservations,
		studentToAdd,
	});
	function goToEventList() {
		navigate(ABSOLUTE_PATHS.EVENT_LIST);
	}
	const closeDialogAndGoToEventList = () => {
		setTimeout(() => {
			goToEventList();
		}, 380);
	};
	const changeAttendanceStudentReservation = id => {
		const newStudentsReservation = studentReservations.value.map(
			student => {
				return student.id === id
					? {
							...student,
							attendance: !student.attendance,
					  }
					: student;
			}
		);
		saveAttendanceHandler.toastErrorSaveAttendance.hide();
		saveAttendanceHandler.errorSaveAttendance.set(false);
		studentReservations.set(newStudentsReservation);
		// Habilitando aviso de salida sin guardar
		setCanShowDialogLeavingPage(true);
	};
	const getStudentReservationTableHeaders = () => {
		return HEADERS_TABLE_LIST.map((item, idx, { length }) =>
			idx === length - 1
				? {
						...item,
						control: (
							<AllStudentReservationsCheckbox
								eventData={eventData.value}
								setCanShowDialogLeavingPage={
									setCanShowDialogLeavingPage
								}
								studentReservations={studentReservations}
								attendanceAllStudents={attendanceAllStudents}
								errorSaveAttendance={
									saveAttendanceHandler.errorSaveAttendance
								}
							/>
						),
				  }
				: item
		);
	};
	const getStudentReservationTableHeadersSancionados = () => {
		return HEADERS_TABLE_LIST_SANCIONADOS.map((item) =>
			item
		);
	};
	//#endregion
	return (
		<Container>
			<HelmetUTP title="Eventos - Asistencia" />
			<ToastMessage
				hidden={hiddenToastSuccessAddReservation}
				message={`Agregaste al alumno ${studentToAdd.value.toastId}`}
			/>
			<ToastMessage
				{...saveAttendanceHandler.toastErrorSaveAttendance.value}
				variant="error"
			/>
			<BackToView
				text="Volver a eventos"
				to={ABSOLUTE_PATHS.EVENT_LIST}
			/>
			{eventData.teacherMustBeTakeHisAttendance() && (
				<TakeTeacherAttendancePanel
					loadingRequest={loadingRequest}
					studentReservations={studentReservations}
					eventData={eventData}
				/>
			)}
			<Content ref={$content}>
				<HeaderComponent eventData={eventData} />
				<AttendanceFields
					changeSearchedStudent={searchedStudent.change}
					eventData={eventData.value}
					searchedStudent={searchedStudent.value}
					searchStudent={searchStudent}
					pinStudentReservation={pinReservationStudent.pin}
					studentToAdd={studentToAdd}
					studentsFoundList={foundStudentList.value}
				/>
				<h3>Alumnos Inscritos {`(${studentReservations.value.length})`}</h3>
				<CustomTableList
					headers={getStudentReservationTableHeaders()}
					minWidth="560px"
				>
					{studentReservations.value.map((item, idx, { length }) => (
						<ListItem
							key={item.id}
							isPinned={pinReservationStudent.isPinned(item.id)}
							disabled={!eventData.value.isPresential}
							dataOfList={{
								index: idx,
								length: length,
							}}
							changeAttendance={
								changeAttendanceStudentReservation
							}
							errorSaveAttendance={
								saveAttendanceHandler.errorSaveAttendance.value
							}
							{...item}
						/>
					))}
				</CustomTableList>

				<h3>Alumnos sin inscripción activa {`(${studentSanctioned.value.length})`}</h3>
				<h5>Lista de alumnos que fueron dados de baja.</h5>
				<CustomTableList
					headers={getStudentReservationTableHeadersSancionados()}
					minWidth="560px"
				>
					{studentSanctioned.value.map((item, idx, { length }) => (
						<ListItemSancionado
							key={item.id}
							isPinned={pinReservationStudent.isPinned(item.id)}
							dataOfList={{
								index: idx,
								length: length,
							}}
							{...item}
						/>
					))}
				</CustomTableList>
			</Content>
			<Footer
				closeAndGoToEventList={closeDialogAndGoToEventList}
				eventData={eventData.value}
				goToEventList={goToEventList}
				saveAttendance={saveAttendanceHandler.saveAttendance}
				studentsReservation={studentReservations.value}
			/>
			<DialogResultSearchStudent
				dialog={dialogResultSearchStudent}
				addStudentReservation={addStudentReservation}
				studentToAdd={studentToAdd.value}
			/>
			<DialogExitWithoutSaveAttendance
				showDialogLeavingPage={showDialogLeavingPage}
				cancelNavigation={cancelNavigation}
				confirmNavigation={confirmNavigation}
			/>
			<DialogSaveAttendance
				closeDialogAndGoToEventList={closeDialogAndGoToEventList}
				dialog={dialogSaveAttendance}
			/>
			<Preloader {...loadingRequest.value} />
		</Container>
	);
};

export default EventAttendanceComponent;
